import type { MouseEvent, ReactNode } from "react";
import { Breadcrumb } from "@mijadesign/web";
import { navigateRuntimeUrl, type NavigationHistory } from "@mijalowcode/utils";

type BreadcrumbItem = {
  title?: ReactNode;
  href?: string;
  path?: string;
  onClick?: (event: MouseEvent<HTMLElement>) => void;
  [key: string]: unknown;
};

type BreadcrumbWrapperProps = {
  items?: BreadcrumbItem[];
  __nodeId?: string;
  __pageApis?: unknown;
  __registerCapabilities?: unknown;
  __runtimeContext?: unknown;
  runtime?: {
    context?: {
      history?: NavigationHistory;
    };
  };
  [key: string]: unknown;
};

function resolveItemUrl(item: BreadcrumbItem) {
  const href = String(item.href || "").trim();
  if (href) return href;
  const path = String(item.path || "").trim();
  if (!path) return "";
  if (/^https?:\/\//i.test(path)) return path;
  return path.startsWith("/") ? path : `/${path}`;
}

function BreadcrumbWrapper({
  items,
  runtime,
  __nodeId: _nodeId,
  __pageApis: _pageApis,
  __registerCapabilities: _registerCapabilities,
  __runtimeContext: _runtimeContext,
  ...rest
}: BreadcrumbWrapperProps) {
  const history = runtime?.context?.history;
  const finalItems = Array.isArray(items)
    ? items.map((item) => {
        const url = resolveItemUrl(item);
        if (!url) return item;
        return {
          ...item,
          href: item.href || url,
          onClick: (event: MouseEvent<HTMLElement>) => {
            item.onClick?.(event);
            if (event.defaultPrevented) return;
            event.preventDefault();
            navigateRuntimeUrl(url, { history });
          },
        };
      })
    : items;

  return <Breadcrumb {...rest} items={finalItems} />;
}

export default BreadcrumbWrapper;
